import { shippingRepository } from "../repository/ShippingRepository";

export const shippingService = {
  getShippingFee: async (onSuccess, onError) => {
    shippingRepository
      .getShippingFee()
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  updateShippingFee: async (data, onSuccess, onError) => {
    shippingRepository
      .updateShippingFee(data)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
};
